"use client";

import { useSubscription } from "@/features/billing/hooks/use-subscription";

/** The plan feature gate for the Meetings area (spec §7.2; decision 149). */
export function useConversationsFeature(): boolean {
  const { data } = useSubscription();
  return data?.plan?.features?.conversation_capture === true;
}
